export const APP_NAME = 'KrishiFin'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = ''
